'use client';

import { cn } from '@/lib/ui/cn';
import { BlocksVideoProps } from '@/types/blocks';
import dynamic from 'next/dynamic';

const Player = dynamic(() => import('next-video/player'), { ssr: false });

export function Video(props: BlocksVideoProps) {
  const { video, videoPoster, rounded, ...rest } = props;

  return (
    <>
      {video && (
        <div
          {...rest}
          data-component='video'
          data-test='video'
          className='flex h-full w-full items-center justify-center'
        >
          <div
            className={cn('w-full', rounded && 'overflow-hidden rounded-4xl')}
          >
            <Player src={video} poster={videoPoster} />
          </div>
        </div>
      )}
    </>
  );
}
